import { io } from "socket.io-client";
import { SOCKET_URL } from "helpers/api_helper";

// export const socket = io(SOCKET_URL);

// // export const socket = io(SOCKET_URL, {
// //   transports: ["websocket"],
// // });

export const socket = io(SOCKET_URL, {
  withCredentials: true,
  transports: ["websocket"],
});

// // const io = new Server(server, {
// //   cors: { origin: allowedOrigins, withCredentials: true },
// //   transports: ["websocket"],
// // });
